import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeData";

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Esplora le Categorie
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Sfoglia tutte le categorie di prodotti disponibili su ItaoBuy Sheet. Ogni categoria ti porta direttamente ai migliori prodotti selezionati con prezzi competitivi e spedizione internazionale.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-4 bg-background-50 rounded-2xl border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-accent-300 hover:bg-accent-50"
            >
              <div className="relative w-full aspect-square rounded-xl overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`${cat.name} - ItaoBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs text-accent-500`}></i>
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-accent-500 transition-colors text-center whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 p-6 md:p-8 bg-accent-500 rounded-2xl">
          <div className="flex flex-col md:flex-row gap-6 items-center">
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2">
                La potenza di ItaoBuy Sheet
              </h3>
              <p className="text-white/80 text-sm leading-relaxed max-w-2xl">
                ItaoBuy Spreadsheet ti permette di creare un sistema organizzato per gestire centinaia di prodotti, monitorare le variazioni di prezzo e tenere traccia di tutti i tuoi ordini in un unico posto. Semplice, professionale ed efficace.
              </p>
              <div className="flex flex-wrap items-center gap-4 mt-4 justify-center md:justify-start">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-accent-500 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap transition-all duration-200 hover:bg-white/90"
                >
                  itaobuy sheet
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </a>
                <Link
                  to="/articoli/guida-completa-itaobuy-spreadsheet"
                  className="inline-flex items-center gap-2 text-white/70 text-sm hover:text-white transition-colors cursor-pointer"
                >
                  Leggi la Guida Completa
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}